import {
  type ListSessionOutcomesQuery,
  type SessionOutcomePage,
  SessionOutcomePageSchema,
} from '@sbc/domain-models/agents';
import { useQuery } from '@tanstack/react-query';

import { apiGet } from './client';

const OUTCOMES_KEY = ['admin', 'outcomes'];

function toSearch(query: ListSessionOutcomesQuery): string {
  const params = new URLSearchParams();
  params.set('page', String(query.page));
  params.set('pageSize', String(query.pageSize));
  if (query.kind) {
    params.set('kind', query.kind);
  }
  if (query.confidence) {
    params.set('confidence', query.confidence);
  }
  if (query.groupKey) {
    params.set('groupKey', query.groupKey);
  }
  if (query.sessionId) {
    params.set('sessionId', query.sessionId);
  }
  if (query.needsReview !== undefined) {
    params.set('needsReview', String(query.needsReview));
  }
  return params.toString();
}

export function useSessionOutcomes(query: ListSessionOutcomesQuery) {
  return useQuery<SessionOutcomePage>({
    queryKey: [...OUTCOMES_KEY, 'list', query],
    queryFn: () => apiGet(`/api/admin/outcomes?${toSearch(query)}`, SessionOutcomePageSchema),
  });
}
